var render = function (_h,_vm) {var _c=_vm._c;return (typeof _vm.props.isVisible !== 'undefined' ? _vm.props.isVisible : true)?_c('div',{staticClass:"small-loading-spinner"},[_vm._m(0)]):_vm._e()}
var staticRenderFns = [function (_h,_vm) {var _c=_vm._c;return _c('div',{staticClass:"spinner"},[_c('div',{staticClass:"spinner__dot-1"}),_vm._v(" "),_c('div',{staticClass:"spinner__dot-2"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-10e5b9ae","hasScoped":false,"buble":{"transforms":{"stripWithFunctional":true}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Common/SmallLoadingSpinner/index.vue
// module id = 1215
// module chunks = 0 3